import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';

const contact = () => {
  const link = $('[href="#contact"]');
  const contactModal = $('#contact');
  const header = $('.c-header');
  const menu = $('.c-main-nav__list');

  if (link && link.length) {
    link.click(ev => {
      ev.preventDefault();
      let $self = $(ev.target);
      if (!$self.attr('href')) {
        $self = $self.closest('a');
      }
      contactModal.modal('show');
      menu.removeClass('active');
    });
  }

  contactModal.on('show.bs.modal', () => {
    setTimeout(() => {
      header.css('padding-right', $('body').css('padding-right'));
    });
  });

  contactModal.on('hidden.bs.modal', () => {
    header.removeAttr('style');
  });
};
export default contact;



// WEBPACK FOOTER //
// ./src/scripts/modules/contact.js